import React from "react";
import { IconT } from "types/utils";

const PowurLogoMobile = ({ height = "22", width = "21" }: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.759766"
        y="18.7979"
        width="24.7479"
        height="2.74977"
        rx="0.25"
        transform="rotate(-45 0.759766 18.7979)"
        fill="#20C2F1"
        stroke="#20C2F1"
        strokeWidth="0.5"
      />
      <rect
        x="2.70508"
        y="1.29883"
        width="24.7479"
        height="2.74977"
        rx="0.25"
        transform="rotate(45 2.70508 1.29883)"
        fill="#20C2F1"
        stroke="#20C2F1"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default PowurLogoMobile;
